/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FeaturedCommentContainer_story = {
    readonly url: string;
    readonly commentCounts: {
        readonly tags: {
            readonly FEATURED: number;
        };
    };
    readonly " $fragmentRefs": FragmentRefs<"UserTagsContainer_story">;
    readonly " $refType": "FeaturedCommentContainer_story";
};
export type FeaturedCommentContainer_story$data = FeaturedCommentContainer_story;
export type FeaturedCommentContainer_story$key = {
    readonly " $data"?: FeaturedCommentContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"FeaturedCommentContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeaturedCommentContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "CommentCounts",
            "kind": "LinkedField",
            "name": "commentCounts",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "CommentTagCounts",
                    "kind": "LinkedField",
                    "name": "tags",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "FEATURED",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserTagsContainer_story"
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '9d62b946570a00336622a281f51c1f55';
export default node;
